export default function CTASection() {
  const handleExternalLink = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="container-site">
        <div className="grid grid-cols-1 lg:grid-cols-2 rounded-2xl overflow-hidden border border-background-200">
          <div className="relative h-[300px] lg:h-auto overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20lifestyle%20photography%20of%20a%20modern%20online%20shopping%20concept%20with%20a%20laptop%20displaying%20product%20listings%20beside%20curated%20fashion%20accessories%20on%20a%20warm%20oak%20desk%2C%20soft%20natural%20window%20light%2C%20editorial%20commercial%20aesthetic%2C%20clean%20composition%2C%20neutral%20cream%20and%20beige%20tones%20with%20subtle%20greenery%20accent&width=800&height=600&seq=cta-fashion-x02&orientation=landscape"
              alt="Mulebuy Spreadsheet trusted sellers fashion products"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/10 to-transparent"></div>
          </div>

          <div className="flex flex-col justify-center items-center text-center bg-white p-10 md:p-12 lg:p-16">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
              Access the
              <br />
              Main Store
            </h2>
            <p className="mt-5 text-foreground-600 text-sm md:text-base max-w-sm leading-relaxed">
              Ready to discover the latest finds? Access the updated Mulebuy Spreadsheet and explore trusted products, verified sellers, and buying guides all in one place.
            </p>
            <button
              onClick={() => handleExternalLink("https://kaspreadsheet.com")}
              className="whitespace-nowrap cursor-pointer mt-6 inline-flex items-center gap-2 bg-primary-500 text-white px-8 py-4 rounded-full font-semibold text-sm hover:bg-primary-600 transition-colors duration-200"
            >
              Visit Kaspreadsheet.com
              <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}